<div class="confirmation-modal-container" *ngIf="!data.simpleDialog">
  <h2 class="confirmation-modal-header" *ngIf="data.action">Are you sure you want to {{ data.action }}?</h2>
  <h2 class="confirmation-modal-header" *ngIf="data.title && !data.action">{{ data.title }}?</h2>
  <div *ngIf="data.description" class="preText">{{ data.description }}</div>
  <ng-template #dynamicInsert></ng-template>
  <div *ngIf="data.textMatcherValue" class="confirmation-modal-text-matcher">
    <p>
      <b>This action is permanent and cannot be undone.</b> If you are sure, please type "{{ data.textMatcherValue }}"
      in the filed below.
    </p>
    <mat-form-field appearance="outline" class="value-description">
      <input data-testid="confirm-delete" matInput type="text" [(ngModel)]="textMatcherValue" />
    </mat-form-field>
  </div>
  <div *ngIf="data.okButtonText == 'Decline Invitation'">
    <mat-form-field style="display: block" appearance="outline" floatLabel="always" class="mat-body-1">
      <mat-label>Reason for declining (optional)</mat-label>
      <textarea
        style="height: 100px"
        autoFocus
        matInput
        forbidAngleBrackets
        matTextareaAutosize
        [(ngModel)]="declineReason"
        class="text-area"
      ></textarea>
    </mat-form-field>
  </div>
  <div mat-dialog-actions>
    <button
      mat-raised-button
      [ngClass]="data.delete ? 'mat-warn' : 'mat-primary'"
      [mat-dialog-close]="true"
      [disabled]="isMainButtonDisabled()"
      (click)="save()"
      id="ok-button"
    >
      {{ data.okButtonText ? data.okButtonText : 'Ok' }}
    </button>
    <button type="button" class="close-button" mat-button [mat-dialog-close]="false" id="cancel-button">CANCEL</button>
  </div>
</div>
<div class="confirmation-modal-container" *ngIf="data.simpleDialog">
  <h2 class="confirmation-modal-header">{{ data.title }}</h2>
  <div class="confirmation-modal-description" *ngIf="data.description">{{ data.description }}</div>
  <ng-template #dynamicInsert></ng-template>
  <div mat-dialog-actions>
    <button
      [attr.id]="data.okButtonId"
      mat-raised-button
      [ngClass]="data.delete ? 'mat-warn' : 'mat-primary'"
      [mat-dialog-close]="true"
      [disabled]="isMainButtonDisabled()"
    >
      {{ data.okButtonText ? data.okButtonText : 'Ok' }}
    </button>
    <button *ngIf="data.delete" type="button" class="close-button" mat-button [mat-dialog-close]="false">CANCEL</button>
  </div>
</div>
